import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
// import { motion } from "framer-motion";
import { LuCalendarHeart } from "react-icons/lu";
// import { ShoppingCart } from "lucide-react";
import useAuthStore from "../../Store/AuthStore.jsx";
import useAppStore from "../../Store/SearchStore.jsx";
import useCartStore from "../../Store/CartStore.jsx";
import { useTranslation } from "react-i18next";
import Logo from "./Logo.jsx";
import NavigationLinks from "./NavigationLinks.jsx";
import AccountMenu from "./AccountMenu.jsx";
import EventNotification from "./EventNotification.jsx";
import MobileMenu from "./MobileMenu.jsx";
import LanguageSelector from "./LanguageSelector.jsx";
import { Button, IconButton } from "../ui/Button/index.js";

// import FloatingCart from "./FloatingCart.jsx";
// import CartDropdown from "./CartDropdown.jsx";

export default function NavBar() {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [showMessage, setShowMessage] = useState(true);
  // const [isCartHovered, setIsCartHovered] = useState(false);
  // const [isBumping, setIsBumping] = useState(false);
  const { logout, isAuthenticated: isLoggedIn } = useAuthStore();
  const { setSearchText, setTag } = useAppStore();
  const { cart, getCartCount } = useCartStore();
  const { t } = useTranslation();
  const history = useHistory();

  const handleClick = () => {
    setSearchText("");
    setTag("");
  };

  // const cartCount = getCartCount();

  // useEffect(() => {
  //   if (cartCount > 0) {
  //     setIsBumping(true);
  //     const timer = setTimeout(() => setIsBumping(false), 300);
  //     return () => clearTimeout(timer);
  //   }
  // }, [cartCount]);

  // Check if there is any unsaved data in localStorage to conditionally render components
  const hasUnsavedData =
    localStorage.getItem("eventData") || localStorage.getItem("spaceData");

  return (
    <header className="flex h-20 w-full items-center px-4 md:px-6 bg-grey-100 border-b border-gray-300 ">
      <Logo onClick={handleClick} />
      <div className="flex-1 hidden justify-center p-6 lg:flex">
        <NavigationLinks handleClick={handleClick} />
      </div>
      <div className="ml-auto flex items-center gap-1">
        <LanguageSelector className="m-3" />

        {/* Cart Icon */}
        {/* <div
          className="relative mr-2"
          onMouseEnter={() => setIsCartHovered(true)}
          onMouseLeave={() => setIsCartHovered(false)}
        >
          <motion.div
            animate={isBumping ? { scale: [1, 1.3, 1], rotate: [0, -10, 10, 0] } : { scale: 1 }}
            transition={{ duration: 0.3 }}
          >
            <IconButton
              onClick={() => history.push("/checkout")}
              variant="outline"
              size="iconSm"
              rounded="full"
              withMotion={true}
              icon={<ShoppingCart className="h-5 w-5 text-neutral-600" />}
              tooltip={t("navigation.cart")}
            />
          </motion.div>
          {cartCount > 0 && (
            <motion.span
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              key={cartCount}
              className="absolute -top-1 -right-1 flex h-4 w-4 items-center justify-center rounded-full bg-red-500 text-[10px] font-bold text-white ring-2 ring-white"
            >
              {cartCount}
            </motion.span>
          )}
          <CartDropdown isOpen={isCartHovered} onClose={() => setIsCartHovered(false)} />
        </div>

        <FloatingCart /> */}

        {isLoggedIn && (
          <IconButton
            as={Link}
            to="/profile"
            variant="outline"
            size="iconSm"
            rounded="full"
            withMotion={false}
            icon={<LuCalendarHeart className="h-5 w-5 text-red-400" />}
            tooltip={t("navigation.events")}
          />
        )}
        {!isLoggedIn && hasUnsavedData && (
          <EventNotification
            showMessage={showMessage}
            setShowMessage={setShowMessage}
            history={history}
          />
        )}
        <AccountMenu isLoggedIn={isLoggedIn} logout={logout} />
        {!isLoggedIn && (
          <Button
            onClick={() => history.push("/login")}
            variant="default"
            size="sm"
            fullWidth
          // className="px-6"
          >
            {t("auth.login")}
          </Button>
        )}
        <MobileMenu
          isNavOpen={isNavOpen}
          setIsNavOpen={setIsNavOpen}
          handleClick={handleClick}
        />
      </div>
    </header>
  );
}
